module.exports = __webpack_public_path__ + "img/shop_storage_1.7ba21fdb.jpg";